import React, { createContext, useContext, useState } from "react";
import { ExternalLink, X } from "lucide-react";

const Ctx = createContext({ openExternal: () => {} });
export const useExternalLink = () => useContext(Ctx);

const hostOf = (url) => { try { return new URL(url).hostname.replace(/^www\./, ""); } catch { return url; } };

export const ExternalLinkProvider = ({ children }) => {
  const [url, setUrl] = useState(null);
  const openExternal = (u) => setUrl(u);
  const cancel = () => setUrl(null);
  const proceed = () => {
    if (url) window.open(url, "_blank", "noopener,noreferrer");
    setUrl(null);
  };

  return (
    <Ctx.Provider value={{ openExternal }}>
      {children}
      {url && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" data-testid="external-link-modal" onClick={cancel}>
          <div className="bg-[#121212] border border-white/10 max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-lg text-white flex items-center gap-2"><ExternalLink size={18} className="text-[#D4AF37]" /> Leaving Sovereign Signal</h3>
              <button onClick={cancel} data-testid="external-link-close" className="text-zinc-500 hover:text-white"><X size={18} /></button>
            </div>
            <p className="font-body text-sm text-zinc-400 leading-relaxed mb-3">You're about to open an external site. Sovereign Signal can't vouch for what's on the other side.</p>
            <div className="bg-[#0A0A0A] border border-white/10 px-3 py-3 mb-5">
              <div className="font-body text-[10px] uppercase tracking-widest text-zinc-500 mb-1">Destination</div>
              <div className="font-heading text-sm text-[#14A89A] break-all">{hostOf(url)}</div>
              <div className="font-body text-[11px] text-zinc-600 break-all mt-1">{url}</div>
            </div>
            <div className="flex gap-3">
              <button onClick={cancel} data-testid="external-link-cancel" className="flex-1 border border-white/15 text-zinc-300 px-4 py-2.5 font-body text-sm hover:bg-white/5 transition-colors">Cancel</button>
              <button onClick={proceed} data-testid="external-link-continue" className="flex-1 bg-[#14A89A] text-[#0A0A0A] font-medium px-4 py-2.5 font-body text-sm hover:bg-[#2BC4B5] transition-colors flex items-center justify-center gap-2"><ExternalLink size={15} /> Continue</button>
            </div>
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
};
